const user = (state = null, action) => {
  switch (action.type) {
    case "SET_USER_DATA":
      state = action.payload
      return state
    default:
      return state
  }
}

export default user
